interface State {
  accountName: string
  accountNameChanged: boolean
  emailSaving: boolean
  saving: boolean
  allowApproval: boolean
  allowLoginTracking: boolean
}

export const ActionType = {
  setAccountName: 'setAccountName',
  setAccountNameChanged: 'setAccountNameChanged',
  setSaving: 'setSaving',
  setEmailSaving: 'setEmailSaving',
  setAllowApproval: 'setAllowApproval',
  setAllowLoginTracking: 'setAllowLoginTracking',
} as const

export type ActionType = (typeof ActionType)[keyof typeof ActionType]

type Action =
  | { type: typeof ActionType.setAccountName; payload: string }
  | { type: typeof ActionType.setAccountNameChanged; payload: boolean }
  | { type: typeof ActionType.setSaving; payload: boolean }
  | { type: typeof ActionType.setEmailSaving; payload: boolean }
  | { type: typeof ActionType.setAllowApproval; payload: boolean }
  | { type: typeof ActionType.setAllowLoginTracking; payload: boolean }

export function reducer(state: State, action: Action) {
  switch (action.type) {
    case 'setAccountName': {
      return {
        ...state,
        accountName: action.payload,
      }
    }
    case 'setAccountNameChanged': {
      return {
        ...state,
        accountNameChanged: action.payload,
      }
    }
    case 'setSaving': {
      return {
        ...state,
        saving: action.payload,
      }
    }
    case 'setEmailSaving': {
      return {
        ...state,
        emailSaving: action.payload,
      }
    }
    case 'setAllowApproval': {
      return {
        ...state,
        allowApproval: action.payload,
      }
    }
    case 'setAllowLoginTracking': {
      return {
        ...state,
        allowLoginTracking: action.payload,
      }
    }
    default:
      throw new Error()
  }
}

export const initialState = {
  accountName: '',
  accountNameChanged: false,
  saving: false,
  emailSaving: false,
  allowApproval: false,
  allowLoginTracking: false,
}
